import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _objectSpread2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import { styled } from '@mui/system';
import { PROMETHEAN_TEXT_HEADER, PROMETHEAN_NEUTRAL_WHITE } from '../styles/colors/colors';
import { PROMETHEAN_TYPOGRAPHY_SMALL_TEXT, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02 } from '../styles/typography/typography';
import { PROMETHEAN_MEDIUM_SHADOW } from '../styles/elevation/elevation';
var ROOT_PREFIX = 'EmbersDownloadApp';
export var StyledDownloadApp = styled('div')(_defineProperty({}, "&.".concat(ROOT_PREFIX, "-root"), _objectSpread(_objectSpread({
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 24px 24px',
  backgroundColor: PROMETHEAN_TEXT_HEADER,
  color: PROMETHEAN_NEUTRAL_WHITE,
  borderRadius: 8
}, PROMETHEAN_MEDIUM_SHADOW), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, ".".concat(ROOT_PREFIX, "-title"), _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SUBTITLE_02), {}, {
  display: 'flex',
  color: PROMETHEAN_NEUTRAL_WHITE,
  columnGap: 10,
  textAlign: 'left',
  img: {
    width: 32,
    height: 32
  },
  span: {
    marginTop: 4
  }
})), _defineProperty(_objectSpread2, ".".concat(ROOT_PREFIX, "-content"), _objectSpread(_objectSpread({}, PROMETHEAN_TYPOGRAPHY_SMALL_TEXT), {}, {
  padding: '12px 0 16px',
  textAlign: 'start',
  color: PROMETHEAN_NEUTRAL_WHITE
})), _defineProperty(_objectSpread2, ".".concat(ROOT_PREFIX, "-download"), _defineProperty({
  textAlign: 'left',
  img: {
    cursor: 'pointer'
  }
}, ".".concat(ROOT_PREFIX, "-group"), {
  display: 'flex',
  columnGap: 12
})), _objectSpread2))));